import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import _ from 'lodash';
import { Text, LabelValue, InfoPill } from '../../../../elementals';
import styles from './styles.scss';
import instrument from '@adc/instrument';
import * as graph from '@adc/sdk';
import ListingSellerRepresentativeCard from '../../../../listingSellerRepresentativeCard';
import Icon from '../../../../elementals/icon';
import PopupTooltip from '../../../../overlays/popupTooltip';
const cx = classnames.bind(styles);
const SummarySection = ({ subsections, listing, className, }) => {
    const displayChildren = (key, children) => {
        return children.map((c, i) => {
            switch (c.type) {
                case 'LINE_SEPARATOR':
                    return _jsx("hr", { className: c.className }, `${key}-${i}`);
                case 'LISTING_AGENT':
                    return (_jsx(ListingSellerRepresentativeCard, { listingParties: listing?.parties || [], className: c.className, open: true, viewingFrom: c.viewingFrom }, `${key}-${i}`));
                case 'INFO_PILL':
                    return (_jsx(InfoPill, { size: c.infoPill?.size, backgroundColor: c.infoPill?.backgroundColor, foregroundColor: c.infoPill?.foregroundColor, includeBorder: c.infoPill?.includeBorder, iconName: c.infoPill?.iconName, extraPadding: c.infoPill?.extraPadding, content: c.infoPill?.content, fontWeight: c.infoPill?.fontWeight, elmId: c.infoPill?.elmId }));
                default:
                    return (_jsx("div", { style: { flex: `1 1 calc(50% - 18px)`, wordBreak: 'break-word' }, children: _jsx(LabelValue, { ..._.omit(c, 'width', 'type'), onTooltipMouseOver: () => {
                                _.debounce(() => {
                                    instrument.domainEvent({
                                        type: graph.enums.DomainEventTypeName.FieldClicked,
                                        source: listing?.urn,
                                        data: {
                                            element_type: 'tooltip',
                                            element_id: c?.elmId,
                                            intent: `${c?.elmId}-hovered`,
                                        },
                                    });
                                }, 300)();
                            } }) }, `${key}-${i}`));
            }
        });
    };
    return (_jsx("div", { className: cx('section-container', className), children: subsections.map((s, index) => {
            const elmId = `${s.title?.toLowerCase().replace(/\s/g, '-') || ''}-subsection`;
            return (_jsxs("div", { "data-elm-id": elmId, className: cx('u-mb-2'), children: [_jsxs(Text, { className: cx('u-mb-2'), color: 'grayMedium', size: 'large', weight: 'heavy', children: [s.title, s.tooltip && (_jsx("span", { className: 'u-ml-1', children: _jsx(PopupTooltip, { offset: 0, horizontalOffset: 0, verticalOffset: 0, content: s.tooltip, wide: false, trigger: _jsx(Icon, { size: 'small', color: 'gray', name: 'info-circle', fitted: true, style: { verticalAlign: 'super' }, iconStyle: 'solid', onMouseOver: () => {
                                            _.debounce(() => {
                                                instrument.domainEvent({
                                                    type: graph.enums.DomainEventTypeName
                                                        .FieldClicked,
                                                    source: listing?.urn,
                                                    data: {
                                                        element_type: 'tooltip',
                                                        element_id: elmId,
                                                        intent: `${elmId}-hovered`,
                                                    },
                                                });
                                            }, 300)();
                                        } }) }) }))] }), _jsx("div", { className: cx('section-children-container', s.className), children: displayChildren(s.title ?? '', s.children.filter(c => !c.hide)) })] }, s.title || `title_${index}`));
        }) }));
};
export default SummarySection;
//# sourceMappingURL=index.js.map